import { Editor, Element } from 'slate';

import { deleteAcrossItems, isCrossingSelection } from '../../helpers/utilities/layout/cross-delete';
import { insertKeepingRowItem } from '../../helpers/utilities/layout/keep-in-item';
import { notifyRefused } from '../../helpers/utilities/layout/notify';

export function hasTarget(options) {
  return typeof options === 'object' && options !== null && typeof options.at !== 'undefined';
}

function isBlockNode(editor, node) {
  return Element.isElement(node) === true && Editor.isInline(editor, node) === false;
}

function hasBlocks(editor, nodes) {

  for (let index = 0; index < nodes.length; index++) {
    if (isBlockNode(editor, nodes[index]) === true) {
      return true;
    }
  }

  return false;

}

// A fragment of one text block merges into the caret's block; anything more adds blocks.
function addsBlocks(editor, fragment) {

  if (fragment.length !== 1) {
    return fragment.length > 1;
  }

  return Element.isElement(fragment[0]) === true && hasBlocks(editor, fragment[0].children) === true;

}

function insertAtSelection(editor, addsAnyBlocks, insert) {

  if (isCrossingSelection(editor) === true) {
    deleteAcrossItems(editor);
  }

  if (insertKeepingRowItem(editor, addsAnyBlocks, insert) === false) {
    notifyRefused();
  }

}

// Blocks pasted or inserted at the caret of a row item go into an auto stack with that item
// (spec 3.5 rule 1 and 3.8).
export function withLayoutPaste(editor) {

  const insertFragment = editor.insertFragment;
  const insertNodes = editor.insertNodes;

  editor.insertFragment = function insertFragmentInLayout(fragment, options) {

    if (hasTarget(options) === true) {
      return insertFragment(fragment, options);
    }

    insertAtSelection(editor, addsBlocks(editor, fragment), insertFragment.bind(null, fragment, options));

  };

  editor.insertNodes = function insertNodesInLayout(nodes, options) {

    if (hasTarget(options) === true) {
      return insertNodes(nodes, options);
    }

    const list = [].concat(nodes);

    insertAtSelection(editor, hasBlocks(editor, list), insertNodes.bind(null, nodes, options));

  };

  return editor;

}
